module.exports = __webpack_public_path__ + "static/img/forImgCon.e78c29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/forImgCon.png
// module id = wCwm
// module chunks = 0